export const DEFAULT_FILTERS = {
  search: {
    type: 'search',
    fields: [
      { field: 'id', label: 'ID' },
      { field: 'name', label: 'Name' },
      { field: 'description', label: 'Description' }
    ]
  },
  name: {
    title: 'Name',
    placeholder: 'Search by Name',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'first-line-mono'
  },
  description: {
    title: 'Description',
    placeholder: 'Search by Description',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'file-text-mono'
  },
  number_of_permissions: {
    title: 'Number of Permissions',
    placeholder: 'Search by Number of Permissions',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'lock-2-mono'
  },
  users_assigned: {
    title: 'Users Assigned',
    placeholder: 'Search by Number of Users Assigned',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'user-circle-add-mono'
  },
  created_at: {
    type: 'date-range',
    title: 'Created At',
    icon: 'calendar-2-mono'
  }
};
